import { render, staticRenderFns } from "./SelectCliente.vue?vue&type=template&id=b706a5fa&"
import script from "./SelectCliente.vue?vue&type=script&lang=js&"
export * from "./SelectCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports